import { Link } from "react-router-dom";
import { usePageTitle } from "../utils/usePageTitle";

export default function NotFound() {
usePageTitle("404 Not Found");
  return (
    <>
      <main className="max-w-6xl mx-auto px-6 py-12 text-slate-800 font-sans space-y-4">
        <h2 className="text-3xl font-semibold text-center text-purple-800">
          Ops! Nothing found here
        </h2>
        <p className="text-lg text-slate-600 text-center m-0">
          This page does not exist.
        </p>
        <p className="text-sm text-slate-500 text-center m-0">
          Check the URL or go back to the homepage.
        </p>

        <div className="pt-2 flex justify-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center rounded-md bg-purple-700 px-6 py-2.5 text-sm font-medium text-white transition hover:bg-purple-800"
          >
            Go to Homepage
          </Link>
        </div>
      </main>
    </>
  );
}
